import { Link } from 'react-router-dom';

function TeesProductCard({ product, category }) {
  const basePrice = product.base_price || product.price || 28;
  const onSale = product.on_sale && product.sale_price != null;
  const linkCategory = category || product.category;

  // Empty/missing stock_by_size means unlimited stock for this product (see
  // AdminTees.js / TeesProduct.js) — only flag sold out when every size that
  // does have a tracked count is at zero.
  const stockCounts = product.stock_by_size ? Object.values(product.stock_by_size) : [];
  const isSoldOut = stockCounts.length > 0 && stockCounts.every((qty) => qty <= 0);

  return (
    <Link
      to={`/shop/tees/${linkCategory}/${product.id}`}
      style={{ textDecoration: 'none', color: 'inherit' }}
      data-testid={`product-${product.id}`}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          transition: 'transform 0.2s, box-shadow 0.2s',
          cursor: 'pointer',
          position: 'relative'
        }}
        className="tees-product-card"
      >
        {!isSoldOut && onSale && (
          <span
            style={{
              position: 'absolute',
              top: '12px',
              left: '12px',
              background: '#c0392b',
              color: '#fff',
              fontSize: '11px',
              fontWeight: '700',
              letterSpacing: '1px',
              padding: '4px 10px',
              borderRadius: '4px',
              zIndex: 1
            }}
          >
            SALE
          </span>
        )}

        {/* Product Image */}
        <div style={{
          aspectRatio: '1',
          overflow: 'hidden',
          background: '#f5f5f5',
          position: 'relative'
        }}>
          <img
            src={product.image_url}
            alt={product.title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.3s',
              filter: isSoldOut ? 'grayscale(60%)' : 'none',
              opacity: isSoldOut ? 0.6 : 1
            }}
          />
          {isSoldOut && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'rgba(26,26,26,0.85)',
              color: '#fff',
              fontSize: '13px',
              fontWeight: '700',
              letterSpacing: '2px',
              padding: '8px 20px',
              borderRadius: '4px',
              whiteSpace: 'nowrap'
            }}>
              SOLD OUT
            </div>
          )}
        </div>

        {/* Product Info */}
        <div style={{ padding: '20px' }}>
          <h3 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: '18px',
            fontWeight: '500',
            margin: '0 0 8px',
            color: '#1a1a1a'
          }}>
            {product.title}
          </h3>

          {product.subtitle && (
            <p style={{
              fontSize: '14px',
              color: '#666',
              margin: '0 0 12px',
              lineHeight: '1.4'
            }}>
              {product.subtitle}
            </p>
          )}

          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <span style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
              {onSale ? (
                <>
                  <span style={{ fontSize: '20px', fontWeight: '600', color: '#c0392b' }}>
                    ${product.sale_price}
                  </span>
                  <span style={{ fontSize: '14px', color: '#999', textDecoration: 'line-through' }}>
                    ${basePrice}
                  </span>
                </>
              ) : (
                <span style={{ fontSize: '20px', fontWeight: '600', color: '#1a1a1a' }}>
                  ${basePrice}
                </span>
              )}
            </span>
            <span style={{
              fontSize: '13px',
              color: '#888'
            }}>
              View Details →
            </span>
          </div>
        </div>
      </div>

      <style>{`
        .tees-product-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.12);
        }
        .tees-product-card:hover img {
          transform: scale(1.05);
        }
      `}</style>
    </Link>
  );
}

export default TeesProductCard;
